module.exports = __webpack_public_path__ + "static/favicons/favicon-16x16-c1be95a2147f3240090fecfd21f92f95.png";